module.exports = __webpack_public_path__ + "static/media/ICN_Specs.5c46e3e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Specs.svg
// module id = 164
// module chunks = 0